<template>
  <section class="pb-30">
    <b-loading :isFullPage="false" :active="isLoading" />
    <div class="is-flex">
      <ManageUnitySearch
        class="flex-1"
        :itensFilter="getItemsFilter"
        :tabPersistName="tabPersistName"
      />
      <span
        v-if="!isMobile"
        class="p-5 mt-10 is-clickable"
        @click="downloadUnities"
      >
        <b-tooltip
          :type="isContrast ? 'is-white' : 'is-blue-oil'"
          class="list-sign"
          size="is-large"
          position="is-top"
          :label="General.DOWNLOAD"
        >
          <b-icon
            icon="download"
            :type="isContrast ? 'is-white' : 'is-blue-oil'"
          />
        </b-tooltip>
      </span>
    </div>

    <div
      class="level-left has-text-left spacing-mb-10 is-justify-content-space-between is-align-center"
    >
      <div :class="{ 'custom-control-row': isMobile }">
        <b-tooltip
          :label="App.ManageUnity.REMOVE_FILTER"
          :type="isContrast ? 'is-white' : 'is-blue-oil'"
          size="is-small"
          position="is-right"
          :active="hasStatusFalse"
        >
          <b-switch
            v-model="viewDisabled"
            :disabled="hasStatusFalse"
            class="vertical-align-sub"
          >
            <span class="has-text-weight-semibold">{{
              General.VIEW_DISABLED
            }}</span>
          </b-switch>
        </b-tooltip>
      </div>

      <section v-if="seeBatchActions" class="buttons">
        <b-button
          :type="isContrast ? 'is-white' : 'is-green-lawn'"
          class="has-text-weight-semibold"
          @click="changeCapacityBatch(true)"
        >
          {{ General.ACTIVATE }}
        </b-button>
        <b-button
          :type="isContrast ? 'is-white' : 'is-green-lawn'"
          class="has-text-weight-semibold"
          @click="changeCapacityBatch(false)"
        >
          {{ General.DISABLE }}
        </b-button>
        <b-button
          :type="isContrast ? 'is-white' : 'is-green-lawn'"
          class="has-text-weight-semibold"
          @click="editPermission()"
        >
          {{ App.ManageUnity.UNITY_CONFIG }}
        </b-button>
      </section>
    </div>

    <template v-if="hasLength && !isLoading">
      <b-table
        ref="table"
        key="capacity-list"
        :data="getPartList"
        class="custom-detail-table custom-table-administration custom-6-columns-manage-unity"
        detailed
        customDetailRow
        detailType="is-red"
        :checkable="!isMobile"
        hoverable
        :checkedRows.sync="partSelectList"
        :openedDetailed="[partId]"
        detailKey="id"
        :loading="getIsLoadingManageUnity"
        @check="selectPart"
      >
        <b-table-column v-slot="props" :label="General.ORGAN_ENTITY">
          <template v-if="props.row">
            <b-tooltip
              :type="isContrast ? 'is-white' : 'is-blue-oil'"
              size="is-small"
            >
              <template #content>
                {{
                  `${props.row.abbreviation} - ${props.row.numberFilteredChilds}`
                }}
                {{ General.LISTED_UNITIES }}
              </template>
              <div
                class="
                  has-text-color-8
                  has-text-weight-semibold
                  is-clickable
                  is-uppercase
                  has-text-left
                "
                @click="props.toggleDetails(props.row)"
              >
                {{ props.row.name }}
                {{ `- ${props.row.abbreviation}` }}
              </div>
            </b-tooltip>
          </template>
        </b-table-column>

        <b-table-column
          v-slot="props"
          :label="App.ManageUnity.SUITE_LEVEL"
          cellClass="has-text-centered is-flex"
        >
          <template v-if="props.row">
            {{ props.row.lvl_suite || App.ManageUnity.EMPTY_LEVEL }}
          </template>
        </b-table-column>

        <b-table-column v-slot="props" :label="General.ACTIVE">
          <template v-if="props.row">
            <b-switch
              :value="props.row.has_active_capacity"
              @input="value => changePartState(props.row.id, value)"
            />
          </template>
        </b-table-column>

        <b-table-column :label="isMobile ? '' : General.ACTIONS">
          <div></div>
        </b-table-column>

        <template #detail="partObject">
          <template v-if="Object.keys(listFiltered).length > 1">
            <template v-for="capacity in getById(partObject.row.childs)">
              <ManageUnityRow
                v-if="listFiltered[capacity.id]"
                :key="`capacity_${capacity.id}`"
                itemClass="pl-10"
                :row="{
                  ...capacity,
                  check: capacitySelectList.includes(capacity.id)
                }"
                :changeState="changeStateCapacity"
                :changeCollection="openModalToggleUnity"
              />
              <template v-for="entity in getById(capacity.childs)">
                <ManageUnityRow
                  v-if="listFiltered[entity.id]"
                  :key="`capacity_entity_${entity.id}`"
                  itemClass="pl-40"
                  :row="{
                    ...entity,
                    check: capacitySelectList.includes(entity.id)
                  }"
                  :changeState="changeStateCapacity"
                  :changeCollection="openModalToggleUnity"
                />
                <template v-for="unity in getById(entity.childs)">
                  <ManageUnityRow
                    v-if="listFiltered[unity.id]"
                    :key="`capacity_unity_${unity.id}`"
                    itemClass="pl-70"
                    :row="{
                      ...unity,
                      check: capacitySelectList.includes(unity.id)
                    }"
                    :changeState="changeStateCapacity"
                    :changeCollection="openModalToggleUnity"
                  />
                  <template v-for="cell in getById(unity.childs)">
                    <ManageUnityRow
                      v-if="listFiltered[cell.id]"
                      :key="`capacity_cell_${cell.id}`"
                      itemClass="pl-100"
                      :row="{
                        ...cell,
                        check: capacitySelectList.includes(cell.id)
                      }"
                      :changeState="changeStateCapacity"
                      :changeCollection="openModalToggleUnity"
                    />
                    <template v-for="cellChild in getById(cell.childs)">
                      <ManageUnityRow
                        v-if="listFiltered[cellChild.id]"
                        :key="`capacity_cell_child_${cellChild.id}`"
                        itemClass="pl-130"
                        :row="{
                          ...cellChild,
                          check: capacitySelectList.includes(cellChild.id)
                        }"
                        :changeState="changeStateCapacity"
                        :changeCollection="openModalToggleUnity"
                      />
                      <template
                        v-for="cellGrandchild in getById(cellChild.childs)"
                      >
                        <ManageUnityRow
                          v-if="listFiltered[cellGrandchild.id]"
                          :key="`capacity_cell_child_${cellGrandchild.id}`"
                          itemClass="pl-150"
                          :row="{
                            ...cellGrandchild,
                            check: capacitySelectList.includes(
                              cellGrandchild.id
                            )
                          }"
                          :changeState="changeStateCapacity"
                          :changeCollection="openModalToggleUnity"
                        />
                        <ManageUnityRow
                          v-for="cellGreatGrandson in getById(
                            cellGrandchild.childs
                          ).filter(child => listFiltered[child.id])"
                          :key="`capacity_cell_child_${cellGreatGrandson.id}`"
                          itemClass="pl-170"
                          :row="{
                            ...cellGreatGrandson,
                            check: capacitySelectList.includes(
                              cellGreatGrandson.id
                            )
                          }"
                          :changeState="changeStateCapacity"
                          :changeCollection="openModalToggleUnity"
                        />
                      </template>
                    </template>
                  </template>
                </template>
              </template>
            </template>
          </template>
          <template v-else>
            <section class="section">
              <NoListMessage v-if="!isLoading" />
              <b-loading v-else :isFullPage="false" :active="isLoading" />
            </section>
          </template>
        </template>
      </b-table>
    </template>
    <section v-else class="section">
      <NoListMessage v-if="!isLoading" />
      <b-loading v-else :isFullPage="false" :active="isLoading" />
    </section>
  </section>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import { General, App } from "@/utils/constants";
import { mapActions, mapGetters, mapMutations } from "vuex";
import NoListMessage from "@/components/NoListMessage";
import ManageUnityRow from "@/components/ManageUnityRow";
import ManageUnitySearch from "@/components/ManageUnitySearch";
import ListDownloadFiles from "@/components/ListDownloadFiles";
import ModalWarning from "@/views/App/ModalWarning";
import ModalCapacityPermissionEdit from "@/views/App/ModalCapacityPermissionEdit";
import { TAB_PERSIST_NAME as PERSIST_NAME } from "@/utils/enumerate";

export default {
  name: "ManageCapacity",

  components: {
    NoListMessage,
    ManageUnityRow,
    ManageUnitySearch
  },

  props: {
    partId: {
      type: Number,
      default: null
    }
  },

  data() {
    return {
      General,
      App,
      viewDisabled: false,
      isLoading: false,
      partSelectList: [],
      capacitySelectList: []
    };
  },

  computed: {
    ...mapGetters({
      user: "getCurrentUser",
      listCapacity: "getListCapacity",
      getManageUnityFilters: "getManageUnityFilters",
      getIsLoadingManageUnity: "getIsLoadingManageUnity",
      isContrast: "isContrast",
      isMobile: "isMobile"
    }),

    seeBatchActions() {
      return this.capacitySelectList.length;
    },

    listFiltered() {
      const partOrCapacity = {};

      const active = this.listCapacity[this.partId]?.has_active_capacity;
      if (active || this.viewDisabled) {
        const filteredCapacity = this.listFilteredCapacity(this.partId);
        const numberFilteredChilds = filteredCapacity.length;
        partOrCapacity[this.partId] = {
          ...this.listCapacity[this.partId],
          numberFilteredChilds
        };
        filteredCapacity.forEach(
          capacity => (partOrCapacity[capacity.id] = capacity)
        );
      }

      return partOrCapacity;
    },

    getPartList() {
      return [this.listFiltered[this.partId]];
    },

    getItemsFilter() {
      return ["CONFIGURATION", "STATUS", "UNITY"];
    },

    hasStatusFalse() {
      const status = this.getManageUnityFilters?.filters?.status;
      return Boolean(status && !status.value);
    },

    filterData() {
      const filters =
        this.getManageUnityFilters?.filters?.configuration?.reduce(
          (acc, actual) => {
            if (!acc[actual.value]) acc[actual.value] = true;
            return acc;
          },
          {}
        ) || {};
      if (
        this.viewDisabled &&
        typeof this.getManageUnityFilters?.filters?.status !== "undefined"
      ) {
        filters.active = this.getManageUnityFilters?.filters?.status?.value;
      } else if (!this.viewDisabled) filters.active = true;
      return filters;
    },

    tabPersistName() {
      return `${PERSIST_NAME.MANAGE_UNITY}_${this.user.id}`;
    },

    hasLength() {
      return this.getPartList[0]?.childs?.length;
    }
  },

  watch: {
    getManageUnityFilters() {
      this.capacitySelectList = [];
      this.partSelectList = [];
      this.filterName = this.getManageUnityFilters.searchValue;
      this.setIsLoadingManageUnity(false);
    },

    hasStatusFalse(value) {
      if (value) this.viewDisabled = true;
    }
  },

  async beforeMount() {
    this.isLoading = true;
    await this.capacityControlRequest(this.partId);
    this.isLoading = false;
  },

  methods: {
    ...mapActions({
      requestLinkDownloadUnity: "requestLinkDownloadUnity",
      capacityControlRequest: "capacityControlRequest",
      changeCapacityState: "changeCapacityState",
      changeStatePart: "changePartState",
      partControlRequest: "partControlRequest"
    }),

    ...mapMutations([
      "setItemDownload",
      "clearListDownloadFiles",
      "setIsLoadingManageUnity"
    ]),

    getById(ids) {
      if (Array.isArray(ids)) {
        const list = [];
        for (const id of ids) {
          const entity = this.listCapacity[id];
          if (entity) list.push(entity);
        }
        return list;
      } else return this.listCapacity[ids];
    },

    listCapacityIds(id) {
      if (Array.isArray(id))
        return id.reduce(
          (acc, actual) => acc.concat(this.listCapacityIds(actual)),
          []
        );
      else {
        const part = this.listCapacity[id];
        if (!part) return [];
        if (part.childs.length) {
          return part.childs.reduce(
            (acc, actual) => acc.concat(this.listCapacityIds(actual)),
            [id]
          );
        }
        return [id];
      }
    },

    listFilteredCapacity(id) {
      const part = this.listCapacity[id];
      if (!part) return [];
      const startList = part.lvl_suite && this.filterCheck(part) ? [part] : [];
      if (part.childs.length) {
        return part.childs.reduce(
          (acc, actual) => acc.concat(this.listFilteredCapacity(actual)),
          startList
        );
      }
      return startList;
    },

    filterCheck(entity) {
      return (
        (this.viewDisabled || entity.active) &&
        this.filterCheckUnity(entity) &&
        this.filterCheckConfig(entity) &&
        this.filterCheckStatus(entity) &&
        this.filterCheckSearch(entity)
      );
    },

    filterCheckConfig(entity) {
      const configuration = this.getManageUnityFilters?.filters?.configuration;
      return !configuration || configuration.some(conf => entity[conf.value]);
    },

    filterCheckUnity(entity) {
      const unities = this.getManageUnityFilters?.filters?.unity?.reduce(
        (acc, actual) => {
          if (actual.name) acc.push(actual.name);
          return acc;
        },
        []
      );

      if (!unities?.length) return true;

      return unities.some(unityName => {
        if (!unityName) return false;
        const regexPattern = new RegExp(unityName.replace(/[.*|()]/g, ""), "i");
        return entity.over_unit_id && regexPattern.test(entity.searchName);
      });
    },

    filterCheckStatus(entity) {
      const status = this.getManageUnityFilters?.filters?.status;
      return !status || status.value === entity.active;
    },

    filterCheckSearch(entity) {
      const search = (this.getManageUnityFilters?.searchValue || "").replace(
        /[.*()]/g,
        ""
      );

      if (!search) return true;

      if (!entity.fullText) {
        let fullText = entity.searchName;

        if (entity.over_unit_id) {
          const topParent = this.listCapacity[this.partId];
          fullText += ` ${topParent.searchName + " "}${
            this.listCapacity[entity.over_unit_id].searchName
          }`;
        }

        this.listCapacity[entity.id].fullText = fullText;
      }
      const regex = RegExp(search, "i");
      return regex.test(entity.fullText);
    },

    changeStateCapacity(capacity_id, active) {
      active
        ? this.capacitySelectList.push(capacity_id)
        : this.capacitySelectList.splice(
            this.capacitySelectList.indexOf(capacity_id),
            1
          );
    },

    async changeCapacityBatch(active) {
      const partList = this.partSelectList.map(part => part.id);
      const capacityList = [];
      this.capacitySelectList.forEach(capacity_id =>
        capacityList.push(...this.listCapacityIds(capacity_id))
      );
      const hasPartSelected = partList.length;

      this.$buefy.modal.open({
        parent: this,
        component: ModalWarning,
        props: {
          title: this.General.WARNING,
          message: active
            ? this.General.TEXTS.CONFIRM_ENABLE_CAPACITY_WITH_CHILDREN
            : this.General.TEXTS.CONFIRM_DISABLE_CAPACITY_WITH_CHILDREN,
          confirm: async () => {
            const finalList = hasPartSelected
              ? partList.map(part_id => ({ part_id, active }))
              : capacityList.map(capacity_id => ({ capacity_id, active }));

            await this.changeState(finalList, hasPartSelected);
          },
          buttons: [
            { label: General.YES, isConfirm: false, action: true },
            { label: General.NO, isConfirm: true, action: false }
          ],
          hasCancelAction: true
        },
        hasModalCard: true,
        trapFocus: true
      });
    },

    async changeState(list, isPart) {
      this.isLoading = true;
      isPart
        ? await this.changePartState(list)
        : await this.changeCapacityState(list);
      await this.capacityControlRequest(this.partId);
      this.partSelectList = [];
      this.capacitySelectList = [];
      this.isLoading = false;
    },

    editPermission() {
      this.$buefy.modal.open({
        parent: this,
        component: ModalCapacityPermissionEdit,
        props: {
          capacity: this.capacitySelectList.map(
            capacity_id => this.listCapacity[capacity_id]
          )
        },
        hasModalCard: true,
        trapFocus: true
      });
    },

    openModalToggleUnity(item, state, update = () => null) {
      if (item.childs.length) {
        this.$buefy.modal.open({
          parent: this,
          component: ModalWarning,
          props: {
            title: this.General.WARNING,
            message: state
              ? this.General.TEXTS.CONFIRM_ENABLE_CAPACITY_WITH_CHILDREN
              : this.General.TEXTS.CONFIRM_DISABLE_CAPACITY_WITH_CHILDREN,
            confirm: () => this.changeCollectionState(item.id, state),
            deny: () =>
              state
                ? this.changeCollectionState(item.id, state, false)
                : update(),
            buttons: [
              { label: General.YES, isConfirm: false, action: true },
              { label: General.NO, isConfirm: true, action: false }
            ],
            hasCancelAction: true
          },
          events: {
            close: () => (item.active = !item.active)
          },
          hasModalCard: true,
          trapFocus: true,
          onCancel: () => (item.active = !item.active)
        });
      } else {
        this.changeCollectionState(item.id, state, false);
      }
    },

    async changeCollectionState(id, state, with_child = true) {
      let list = [];
      if (with_child) {
        list = this.listCapacityIds(id).map(capacity_id => ({
          capacity_id,
          active: state
        }));
      } else list = [{ capacity_id: id, active: state }];
      this.isLoading = true;
      await this.changeState(list);
      await this.capacityControlRequest();
      this.isLoading = false;
    },

    async changePartState(part_id, active) {
      const list = [{ part_id, active }];

      this.isLoading = true;
      await this.changeStatePart(list);
      await this.partControlRequest();
      await this.capacityControlRequest(part_id);
      this.isLoading = false;
    },

    isActive(ids) {
      const list = Array.isArray(ids) ? ids : [ids];
      for (const id of list) {
        const actual = this.listCapacity[id];
        if (
          (actual.description && actual.active) ||
          (actual.childs?.length && this.isActive(actual.childs))
        )
          return true;
      }
      return false;
    },

    downloadUnities() {
      const file_index = uuidv4();

      const parts_list = this.listFilteredCapacity(this.partId)
        .filter(({ id }) => this.viewDisabled || this.isActive(id))
        .map(({ id }) => id);

      this.setItemDownload({
        name: App.ManageUnity.NAME_FILE,
        file_index,
        percentage: 0,
        status: "pending"
      });

      this.snackQueue.open({
        id: "download_files",
        parent: this,
        component: ListDownloadFiles,
        closeAction: this.clearListDownloadFiles
      });

      this.requestLinkDownloadUnity({
        ...this.filterData,
        search: this.filterName,
        file_index,
        parts_list
      });
    },

    selectPart(list, part) {
      const newPart = Boolean(list.find(({ id }) => id === part.id));
      const listCapacities = this.listFilteredCapacity(part.id).map(
        capacity => capacity.id
      );
      if (newPart)
        this.capacitySelectList = this.capacitySelectList.concat(
          listCapacities.filter(
            capacity_id => !this.capacitySelectList.includes(capacity_id)
          )
        );
      else
        this.capacitySelectList = this.capacitySelectList.filter(
          capacity_id => !listCapacities.includes(capacity_id)
        );
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.section {
  display: flex;
  flex-direction: column;
  background-color: $color-1;
  padding: 20px 1.5rem 0 1.5rem;
}
.item-grid {
  display: grid;
  grid-template-columns: 1fr 100px 100px;
  border-bottom: 1px solid $color-7;
  padding-top: 5px;
  padding-bottom: 5px;
}

.custom-control-row {
  @media screen and (max-width: $tablet) {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
}
</style>
